import { render, staticRenderFns } from "./CustomMenu.vue?vue&type=template&id=18769908"
import script from "./CustomMenu.vue?vue&type=script&lang=js"
export * from "./CustomMenu.vue?vue&type=script&lang=js"
import style0 from "./CustomMenu.vue?vue&type=style&index=0&id=18769908&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports